import { BorderColor, TagColor } from '../interface/common';
import { MatterRequestStatus } from './matter';

export const tagColorMapping: {
  [key in MatterRequestStatus]: TagColor;
} = {
  [MatterRequestStatus.open]: TagColor.GREEN,
  [MatterRequestStatus.closed]: TagColor.RED,
  [MatterRequestStatus.rejected]: TagColor.RED,
};

export const cardBorderColorMapping: {
  [key in MatterRequestStatus]: string;
} = {
  [MatterRequestStatus.open]: BorderColor.GREEN,
  [MatterRequestStatus.closed]: BorderColor.RED,
  [MatterRequestStatus.rejected]: BorderColor.YELLOW,
};

export const MATTER_REQUEST_QUERY_KEYS_TO_INVALIDATE = [
  'matter-requests-details',
  'all-matter-requests',
  'company-matter-requests',
  'private-matter-requests',
];
